import { Component } from 'san';
import { Input, Icon } from 'santd';


import LeanInputCell from '../LeanInputCell/LeanInputCell';

export default class LeanProjectTextArea extends Component {
    static components = {
        'ui-lean-input-cell': LeanInputCell,
        's-input': Input,
        's-icon': Icon,
        's-textarea': Input.TextArea,
    };

    constructor(options: any) {
        super(options);
    }

    initData(): {
        focusId: string;    // {{}} 当前focus的组件的id，用来高亮组件
        id: string; // {{}}
        title: string;  // {{}}
        value: string;   // {==}
        placeholder: string;
        isRequired: boolean;    // {{}}
    } {
        return {
            focusId: null,
            id: null,
            title: '',
            value: null,
            placeholder: '(点击回车键进行换行操作)',
            isRequired: false,
        };
    }

    onFocus() {
        this.fire('focus', this.data.get('id'));
    }

    onBlur() {
        this.fire('blur', this.data.get('id'));
    }

    onClick() {
        this.onFocus();
    }

    onIconClick() {
        this.onFocus();
    }

    fireValueChange(value: string) {
        this.fire('value-change', value);
    }
}
